import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let TrucksApiPromise: Promise<AxiosInstance> | null = null;

const getTrucksApi = async (): Promise<AxiosInstance | null> => {
  if (TrucksApiPromise) return TrucksApiPromise;
  TrucksApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return TrucksApiPromise;
};

export interface GetTrucksListProps {
  nombre?: string;
  patente?: string;
  activo?: boolean;
  tipoModulo?: number[];
  "P.Pagina": number;
  "P.Records"?: number;
}

export const getTrucksList = async (props: GetTrucksListProps) => {
  const api = await getTrucksApi();
  if (!api) return;

  const response = await api.get(
    `/Equipos/All?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface GetTruckProps {
  id: number;
}

export const getTruck = async (props: GetTruckProps) => {
  const api = await getTrucksApi();
  if (!api) return;

  const response = await api.get(`/Equipos/${props.id}`);

  return response.data;
};

export interface DeleteTrucksProps {
  Ids: number[];
}

export const deleteTrucks = async (props: DeleteTrucksProps) => {
  const api = await getTrucksApi();
  if (!api) return;

  const response = await api.delete(
    `/Equipos?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface CreateTruckProps {
  nombre: string;
  patente: string;
  modulos: number[];
}

export const createTruck = async (props: CreateTruckProps) => {
  const api = await getTrucksApi();
  if (!api) return;

  const response = await api.post(`/Equipos`, props);

  return response.data;
};

export interface UpdateTruckProps {
  id: number;
  nombre: string;
  patente: string;
  modulos: number[];
  activo: boolean;
}

export const updateTruck = async (props: UpdateTruckProps) => {
    const api = await getTrucksApi();
  if (!api) return;

  const response = await api.put(`/Equipos`, props);

  return response.data;
}